/**
 * Keys accepted by `POST /api/v1/Bubbles/{bubbleId}/emergency-dispatch` (see EmergencyQuickResponseKeys on the API).
 */
export const DISPATCH_EMERGENCY_KEYS = [
  "active-shooter",
  "emergency-evacuation",
  "medical",
  "weather",
  "stranger",
  "fight",
  "srp-hold",
  "srp-secure",
  "srp-lockdown",
  "srp-evacuate",
  "srp-shelter",
] as const;

export type DispatchEmergencyKey = (typeof DISPATCH_EMERGENCY_KEYS)[number];

export function isDispatchKey(key: string): key is DispatchEmergencyKey {
  return (DISPATCH_EMERGENCY_KEYS as readonly string[]).includes(key);
}

/**
 * Built-in keys for emergency notifications and SRP protocol actions (I Love U Guys Standard Response Protocol).
 * @see https://iloveuguys.org/The-Standard-Response-Protocol.html
 *
 * `false-alarm` is not a broadcast emergency; dismissal is configured separately (dismiss groups + original trigger user).
 */
export const CONFIGURABLE_EMERGENCY_ACTIONS = [
  { id: "srp-hold", label: "SRP — Hold" },
  { id: "srp-secure", label: "SRP — Secure" },
  { id: "srp-lockdown", label: "SRP — Lockdown" },
  { id: "srp-evacuate", label: "SRP — Evacuate" },
  { id: "srp-shelter", label: "SRP — Shelter" },
  { id: "active-shooter", label: "Active Shooter" },
  { id: "emergency-evacuation", label: "Emergency Evacuation" },
  { id: "medical", label: "Medical" },
  { id: "weather", label: "Weather" },
  { id: "stranger", label: "Stranger" },
  { id: "fight", label: "Fight" },
] as const;

export function emergencyLabelForKey(key: string): string {
  const row = CONFIGURABLE_EMERGENCY_ACTIONS.find((a) => a.id === key);
  return row?.label ?? key;
}
